module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-1-100.466f283a.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-1-100.png
// module id = 2550
// module chunks = 11